import km from 'keymirror'
import _ from 'underscore'

export default _.extend({}, km({
  CATEGORY_GET_CHILDREN_START: null,
  CATEGORY_GET_CHILDREN_SUCCESS: null,
  CATEGORY_GET_CHILDREN_ERROR: null,

  CATEGORY_GET_PRODUCTS_START: null,
  CATEGORY_GET_PRODUCTS_SUCCESS: null,
  CATEGORY_GET_PRODUCTS_ERROR: null,

  CATEGORY_GET_PRODUCTS_MORE_START: null,
  CATEGORY_GET_PRODUCTS_MORE_SUCCESS: null,
  CATEGORY_GET_PRODUCTS_MORE_ERROR: null,

  CATEGORY_GET_BANNER_SUCCESS: null,
  CATEGORY_GET_BANNER_ERROR: null,
  CATEGORY_GETCATEGORYRECOMMEND_SUCCESS: null,
  CATEGORY_GETCATEGORYRECOMMEND_ERROR: null,

  CATEGORY_GET_OPTIONS_SUCCESS: null, //品类所含筛选项
  CATEGORY_GET_OPTIONS_ERROR: null,
  CATEGORY_GET_OPTION_PRODUCTS_SUCCESS: null,
  CATEGORY_GET_OPTION_PRODUCTS_ERROR: null,
  CATEGORY_GET_OPTION_PRODUCTS_MORE_SUCCESS: null,

  CATEGORY_SET_SELECTED_OPTIONS: null,  //筛选选中项
  CATEGORY_CLEAN_SELECTED_OPTIONS: null,
  CATEGORY_GETCATEGORYFITLERS_SUCCESS: null,
  CATEGORY_GETCATEGORYFITLERS_ERROR: null,
  CATEGORY_FILTERPRODUCTLIST_SUCCESS: null,
  CATEGORY_FILTERPRODUCTLIST_ERROR: null,

  // 筛选栏
  CATEGORY_GET_FILTER_OPTIONS_SUCCESS: null,
  CATEGORY_GET_FILTER_OPTIONS_ERROR: null,

  // 存储筛选条件
  CATEGORY_SAVE_FILTER_OPTIONS: null,
  // 清空筛选条件
  CATEGORY_CLEAR_FILTER_OPTIONS: null,

  // 存储表单数据
  CATEGORY_SAVE_FILTER_OPTIONS_CONDITION: null,
  // 清空表单数据
  CATEGORY_CLEAR_FILTER_OPTIONS_CONDITION: null,

  // 提交筛选表单
  CATEGORY_SUBMIT_FILTER_OPTIONS_SUCCESS: null,
  CATEGORY_SUBMIT_FILTER_OPTIONS_ERROR: null,
  CATEGORY_SUBMIT_FILTER_OPTIONS_MORER_SUCCESS: null,
  CATEGORY_SUBMIT_FILTER_OPTIONS_MORE_ERROR: null,
  CATEGORY_GETWELFAREPRODUCTLIST_SUCCESS: null,
  /*yeoman-template-point-1*/
}))
